import React from 'react';
import styles from './styles.module.css';
import {Container, Layout, SubscribeCard} from '../../../components';

const StaticPageWrapper = ({ img,children,title,subscribe }) => {
  return (
    <Layout>
        <div className={styles.container}>
            <img src={img} alt={"pageWrapperImg"}/>
        </div>

      <Container>
          <div className={styles.titlePosition}>
              {title}
          </div>
          <div style={{whiteSpace:"pre-wrap"}}>
              {children}
          </div>
      </Container>
      {subscribe===false?
      '':
        <SubscribeCard/>
      }
    </Layout>
  );
};
export default StaticPageWrapper;
